import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface Heading3Props extends HTMLAttributes<HTMLHeadingElement> {
  children: ReactNode
  className?: string
}

export const Heading3: FC<Heading3Props> = ({ children, className = '', ...rest }) => (
  <h3 className={`heading-3 ${className}`} {...rest}>
    {children}
  </h3>
)
